import { IUnitNodePermissions, UnitNodePermissions } from "../unit/unitNodePermissions";

export interface IInstantMessagePermission {
    hasPartners: boolean;
    unitNodePermissions: IUnitNodePermissions;
}

export class InstantMessagePermission implements IInstantMessagePermission {
    hasPartners: boolean;
    unitNodePermissions: UnitNodePermissions;

    constructor();
    constructor(obj: IInstantMessagePermission);
    constructor(obj?: any) {
        this.hasPartners = obj && obj.hasPartners || false;
        this.unitNodePermissions = new UnitNodePermissions(obj ? obj.unitNodePermissions : null);
    }
}